import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import { Link } from "react-router-dom";
import hshape from "../assets/img/hshape.svg";
import abImg from "../assets/img/ab-img.jpg";
import abImg2 from "../assets/img/thumbsup.jpg";
const About = () => {
  return (
    <>
      <BreadCrumb />
      <section className="section-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 my-auto">
              <div className="main-h text-start">
                <h1 className="m-heading text-start">About Us</h1>
                <img src={hshape} className='img-fluid ' alt="logo" />
              </div>
              <h5><b>Empowering Care Professionals with Knowledge</b></h5>
              <p> 
                  At <b>Endorse Learning</b>, we are more than just an online training provider—we are a
                  dedicated partner in the growth and success of care professionals. Our mission is to
                  <b>empower individuals and organizations</b> within the health and social care sectors by
                  delivering <b>high-quality, accessible, and industry-relevant training solutions.</b>
              </p>
            </div>
            <div className="col-lg-6 offset-lg-1">
              <img src={abImg} className='img-fluid rounded shadow-sm' alt="logo" />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-f7">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 empty-box bg-img-left">

                    </div>
                    <div className="col-lg-6 bg-text-right">

                        <div className="row justify-content-center">
                            <div className="col-lg-11">
                            <div className="main-h text-start">
                              <h1 className="m-heading text-start">Why Choose Endorse Learning?</h1>
                              <img src={hshape} className='img-fluid ' alt="logo" />
                            </div>
                                <div className="left-icon-box">
                                <i className="bi bi-check-square"></i>
                                    <div className="left-icon-content">
                                        <h5>Expert-Led Courses</h5>
                                       <p>Our courses are developed by industry experts, ensuring that
                                       you receive up-to-date and practical knowledge.</p>
                                    </div>
                                </div>
                                <div className="left-icon-box">
                                <i className="bi bi-check-square"></i>
                                    <div className="left-icon-content">
                                        <h5>Flexible & Affordable</h5>
                                       <p>Learning should be accessible to everyone. That’s why we offer
                                       cost-effective online training that fits into your busy schedule.</p>
                                    </div>
                                </div>
                                <div className="left-icon-box">
                                <i className="bi bi-check-square"></i>
                                    <div className="left-icon-content">
                                        <h5>Compliance & Quality Assurance</h5>
                                       <p>Our courses align with industry standards and best
                                       practices, helping professionals stay compliant and confident in their roles.</p>
                                    </div>
                                </div>
                                <div className="left-icon-box">
                                <i className="bi bi-check-square"></i>
                                    <div className="left-icon-content">
                                        <h5>Career Development & Growth</h5>
                                       <p>Whether you're starting your career or upskilling, our
                                      training programs are designed to help you thrive in the evolving care industry.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section className="section-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 my-auto">
              <div className="main-h text-start">
                <h1 className="m-heading text-start">Our Commitment</h1>
                <img src={hshape} className='img-fluid ' alt="logo" />
              </div>
              
              <p> 
              At Endorse Learning, we believe that <b>education transforms lives</b>. By equipping care
              professionals with essential skills and knowledge, we contribute to a more <b>competent,
              compassionate, and skilled workforce</b>. Our learning platform is designed to be <b>engaging,
              interactive, and supportive</b>, ensuring that every learner can succeed.
              </p>

              <a href="#" className="btn btn-green mt-4">Explore Our Courses Now</a>
            </div>
            <div className="col-lg-6 offset-lg-1">
              <img src={abImg2} className='img-fluid rounded shadow-sm' alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
